import React, { useEffect, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import Breadcrumbs from 'CommonElements/Breadcrumbs';
import DetailContainer from 'Component/DashboardQeza/Branch/Detail/indexAdmin';
import { getBranch } from 'Services/Features/Branch/Utils/branchUtils';
import { setFormData, resetFormData } from 'Services/Features/Branch/branchSlice';
import { GetAdminRole } from 'Component/Common/GetAdminRole';

const BranchDetail = () => {
    const dispatch = useDispatch();
    const filters = useSelector(state => state.branch.filters)
    const currentBranch = useSelector((state) => state.branch.currentBranch);
    const operationHoursState = useSelector((state) => state.branch.currentBranch.operation_hours);
    const user = JSON.parse(localStorage.getItem('USER'));
    const id = user?.branch_id;
    const initializeOperationHours = (itemHours) => {
        try {
            // Cek apakah itemHours sudah berupa object atau masih string
            if (typeof itemHours === 'string') {
                return { ...operationHoursState, ...JSON.parse(itemHours) };
            } else if (typeof itemHours === 'object' && itemHours !== null) {
                return { ...operationHoursState, ...itemHours };
            } else {
                return { ...operationHoursState };
            }
        } catch (error) {
            console.error("Error parsing operation hours:", error);
            return { ...operationHoursState };
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);

        if (id) {
            // Buat filter untuk ambil data berdasarkan ID
            const newFilters = {
                ...filters,
                "filter[id]": id,
                "include": "treatment,doctor",
                page: 1,
            };

            // Fetch data dari API pakai ID
            dispatch(getBranch(newFilters)).then((response) => {
                if (response.payload && response.payload.data?.length > 0) {
                    const item = response.payload.data[0]; // Ambil item pertama (kalau ada)

                    // Simpan photos & banner ke state terpisah
                    dispatch(setFormData({ photosLink: item.photos, bannerLink: item.banner }));

                    // Buat objek baru tanpa photos & banner
                    const { photos, banner, ...updatedItem } = item;

                    dispatch(setFormData({
                        ...updatedItem,
                        operation_hours: initializeOperationHours(item.operation_hours),
                        branch_id: item.id,
                        branch_name: item.name,
                    }));
                }
            });
        } else {
            // Kalau nggak ada ID & data di state, reset form
            dispatch(resetFormData());
        }
    }, [id, currentBranch?.id]);



    return (
        <Fragment>
            <Breadcrumbs parent="Cabang Klinik" title={currentBranch?.branch_name} />
            <DetailContainer/>
        </Fragment>
    );
};
export default BranchDetail;